module.exports = __webpack_public_path__ + "static/lake_aerial_2-83c4049d49b228c07b23b93cf1d77401.jpg";